let ws = null;
let reconnectTimer = null;
let retryCount = 0;

const MAX_RETRIES = 5;
const BASE_DELAY = 1500;

let lastToken = null;
let lastLabId = null;

export const createSocket = (token, labId, onMessage, onError, onStatus) => {
  if (!token) {
    console.error("WebSocket token missing");
    return null;
  }

  lastToken = token;
  lastLabId = labId || "lab1";

  // -----------------------------
  // CLEAN OLD SOCKET SAFELY
  // -----------------------------
  if (ws) {
    try {
      ws.onopen = null;
      ws.onmessage = null;
      ws.onerror = null;
      ws.onclose = null;
      ws.close();
    } catch (e) {}
    ws = null;
  }

  if (reconnectTimer) {
    clearTimeout(reconnectTimer);
    reconnectTimer = null;
  }

  const protocol = window.location.protocol === "https:" ? "wss" : "ws";
  const host = window.location.host;

  const url = `${protocol}://${host}/ws/?token=${encodeURIComponent(token)}`;

  if (onStatus) onStatus("connecting");

  ws = new WebSocket(url);

  // =============================
  // CONNECTED
  // =============================
  ws.onopen = () => {
    console.log("WebSocket connected");

    retryCount = 0;
    if (onStatus) onStatus("connected");

    // ✅ SEND AUTH ONLY ONCE SOCKET IS OPEN
    ws.send(JSON.stringify({
      type: "auth",
      token: lastToken,
      labId: lastLabId
    }));
  };

  // =============================
  // MESSAGES
  // =============================
  ws.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      onMessage?.(data);
    } catch (e) {
      onMessage?.({
        type: "raw",
        data: event.data,
      });
    }
  };

  // =============================
  // ERROR
  // =============================
  ws.onerror = (err) => {
    console.log("WebSocket error", err);
    if (onError) onError(err);
    if (onStatus) onStatus("error");
  };

  // =============================
  // CLOSE + RECONNECT
  // =============================
  ws.onclose = () => {
    console.log("WebSocket closed");

    if (onStatus) onStatus("disconnected");

    if (retryCount < MAX_RETRIES) {
      retryCount++;

      const delay = BASE_DELAY * retryCount;

      reconnectTimer = setTimeout(() => {
        console.log(`Reconnecting WebSocket... attempt ${retryCount}`);

        createSocket(
          lastToken,
          lastLabId,
          onMessage,
          onError,
          onStatus
        );
      }, delay);
    } else {
      console.log("Max WebSocket retries reached");
      if (onStatus) onStatus("failed");
    }
  };

  return ws;
};

// =============================
// SEND INPUT
// =============================
export const sendInput = (data) => {
  if (!ws || ws.readyState !== WebSocket.OPEN) return;

  ws.send(JSON.stringify({
    type: "input",
    data,
  }));
};

// =============================
// CLOSE SOCKET
// =============================
export const closeSocket = () => {
  if (ws) {
    try {
      ws.close();
    } catch (e) {}
    ws = null;
  }

  if (reconnectTimer) {
    clearTimeout(reconnectTimer);
    reconnectTimer = null;
  }

  retryCount = 0;
};